import styled from 'styled-components';


export const UserRoleAccessAddButtonControl = styled.div`

margin-left: 50%;
display: flex;
 
margin-bottom:10px;
column-gap: 20px;
.btn{

}


.right{
   
  
}`;


export const UserRoleAccessFormBottonControl = styled.div`

margin-left: 50%;
display: flex;
 
margin-bottom:30px;
column-gap: 20px;
 
.btn{

}


.right{
    
}`;
